import React, { Component } from 'react';
import { Table, } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class EconomicCalender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            economicCalenderList: [],
        };
    }

    custom_sort(a, b) {
		return new Date(a.date).getTime() - new Date(b.date).getTime();
	}

    componentDidMount() {
        ApiService.getEconomicCalender()
            .then(result => {
                console.log('Economic Calender', result);
                let filteredData = [];
                let length = 14;
                if (result.length > 0) {
                    result.sort(this.custom_sort);
                    for (var i=0; i<result.length; i++){
                        if (result[i].country === 'US'){
                            filteredData.push(result[i]);
                        }
                    }

                    length = filteredData.length < length ? filteredData.length : length;
                    filteredData = filteredData.slice(0, length);
                    console.log('Econimic Calender filter', result, filteredData);
                }
                this.setState({ economicCalenderList: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        if (listValue !== undefined) {
            let result = ''; 
            if (parseFloat(listValue.actual) >= parseFloat(listValue.estimate)){
                result = 'green';
            } else if (parseFloat(listValue.actual) < parseFloat(listValue.estimate)){
                result = 'red';
            } 
            return (
                <tr key={listValue.symbol + Math.random()} style={{ fontSize: '10px', color: result,  fontWeight:'bold'}}>
                    <td>{listValue.date}</td>
                    <td style={{textAlign: 'left'}}>{listValue.event}</td>
                    <td>{listValue.previous}</td>
                    <td>{listValue.estimate}</td>
                    <td>{listValue.actual}</td>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.economicCalenderList !== undefined &&  this.state.economicCalenderList.length !== undefined && this.state.economicCalenderList.length > 0) {
            tableRow = this.state.economicCalenderList.map(this.renderRow.bind(this));
        } else {
            tableRow = <tr><td></td><td>No Data</td><td></td><td></td></tr>
        }
        console.log('economicCalenderList', this.state.economicCalenderList.length);
        return (
            // <div style={{ overflow: 'scroll', height: '475px' }}>
            // <Card border="secondary" style={{ height: '475px' }}>
            // <Card.Header>Economic Calender</Card.Header>             
            <Table bordered hover size="xs" style={{ fontSize: "10px" }} responsive>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th><Link to={'/economicCalender'}>Econonic Events</Link></th>
                        <th>Prior</th>
                        <th>Estimate</th>
                        <th>Actual</th>
                    </tr>
                </thead>
                <tbody>
                    {tableRow}
                </tbody>
            </Table>
            // </Card>
            // </div>
        );
    }
}

export default EconomicCalender;
